export default "__VITE_ASSET__d6d28de1__"